import DevLayout from './DevLayout';

export default DevLayout;
